<h2 mat-dialog-title>
  <mat-icon>schedule</mat-icon>
  Calendario de servicios
</h2>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="formGroup">

    <!-- Selector de contrato -->
    <div class="contract-selection">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contrato</mat-label>
        <mat-select formControlName="selectedContract" [compareWith]="compareContracts">
          @for (contract of activeContractList; track contract) {
            <mat-option [value]="contract">
              <span>{{contract.name}}</span> |
              <small>{{contract.status ? 'Activo' : 'Inactivo'}}</small>
            </mat-option>
          }
        </mat-select>
        <mat-error>Contrato es <strong>requerido</strong></mat-error>
      </mat-form-field>
    </div>

    <!-- Sección de fechas de servicio -->
    @if (formGroup.get('selectedContract')?.value) {
      <div class="service-dates-section">
        <h3>
          <mat-icon color="">event</mat-icon>
          Fechas de Servicio
        </h3>
        <!-- Campo para agregar nueva fecha -->
        <div class="add-service-date">
          <div class="date-type-row">
            <!-- Selector de tipo de mantenimiento -->
            <mat-form-field appearance="outline" class="maintenance-type-field">
              <mat-label>Tipo de mantenimiento</mat-label>
              <mat-select formControlName="maintenanceType">
                @for (type of maintenanceTypes; track type) {
                  <mat-option [value]="type.value">
                    {{type.label}}
                  </mat-option>
                }
              </mat-select>
              <mat-error>Tipo de mantenimiento es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <!-- Campo de fecha -->
            <mat-form-field appearance="outline" class="date-field">
              <mat-label>Nueva fecha de servicio</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="newServiceDate"
                [min]="formGroup.get('maintenanceType')?.value === 'preventivo' ? minDate : null">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (formGroup.get('maintenanceType')?.value === 'correctivo') {<mat-hint>
                  Para mantenimiento correctivo se permiten fechas pasadas
                </mat-hint>}
            </mat-form-field>
          </div>
          <!-- Botón para agregar -->
          <button mat-raised-button color="accent" type="button" (click)="addServiceDate()"
            [disabled]="!formGroup.get('newServiceDate')?.value || !formGroup.get('maintenanceType')?.value">
            <mat-icon>add</mat-icon>
            Agregar Fecha
          </button>
        </div>
        <!-- Lista de fechas de servicio -->
        @if (getServiceDatesWithContracts().length > 0) {
          <div class="service-dates-list">
            <h4>Fechas de servicio programadas:</h4>
            <div class="service-dates-container">
              @for (dateItem of getServiceDatesWithContracts(); track trackByDate(i, dateItem); let i = $index) {
                <div
                  class="service-date-row">
                  <div class="date-content">
                    <mat-icon class="date-icon"
                      [color]="getMaintenanceTypeColor(dateItem.type)">
                      {{getMaintenanceTypeIcon(dateItem.type)}}
                    </mat-icon>
                    <div class="date-details">
                      <div class="primary-text">
                        <strong>{{ dateItem.date | date:'dd/MM/yyyy' }}</strong> -
                        <span class="contract-name">{{contractObj[dateItem.contract] || 'Contrato no encontrado'}}</span>
                      </div>
                      <div class="secondary-text">
                        <span class="maintenance-type-badge"
                          [class]="'badge-' + (dateItem.type || 'preventivo')">
                          <mat-icon class="badge-icon">{{getMaintenanceTypeIcon(dateItem.type || 'preventivo')}}</mat-icon>
                          {{getMaintenanceTypeLabel(dateItem.type || 'preventivo')}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="date-actions">
                    <button mat-icon-button
                      color="warn"
                      (click)="removeServiceDateMaterial(dateItem.date, dateItem.contract, $event)"
                      matTooltip="Eliminar fecha de servicio"
                      type="button"
                      class="delete-btn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- Mensaje cuando no hay fechas para el contrato seleccionado -->
        @if (serviceDates.length === 0) {
          <div class="no-dates-message">
            <mat-icon color="">info</mat-icon>
            <span>No hay fechas de servicio programadas para este contrato</span>
          </div>
        }
      </div>
    }

    <!-- Mensaje cuando no se ha seleccionado contrato -->
    @if (!formGroup.get('selectedContract')?.value) {
      <div class="no-contract-message">
        <mat-icon color="">warning</mat-icon>
        <span>Seleccione un contrato para programar fechas de servicio</span>
      </div>
    }

  </form>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="warn">Cancelar</button>
  <button mat-raised-button color="primary" (click)="update()">Guardar</button>
</mat-dialog-actions>